<div *ngIf="!faceRecognitionService.classifiersLoadFinished">
  <div class="loader">
  </div>
</div>
<div class="text-center" style="height: 500px; min-height: 500px; max-height: 500px">
  <div [style.visibility]="((faceRecognitionService.classifiersLoadFinished)? 'visible': 'hidden')">
    <div>
      <h3 class="blink_me" style="font-size: 12px; color:red">
        &nbsp;{{emotionService.emotionalLocalMsg0}}
      </h3>
    </div>
    <div style="display: block;" *ngIf="currentPrediction != null">
      <canvas mdbChart
              [chartType]="chartType"
              [datasets]="chartDatasets"
              [labels]="chartLabels"
              [colors]="chartColors"
              [options]="chartOptions"
              [legend]="false">
      </canvas>
    </div>
    <div style="font-size: 16px">
      {{emotionService.emotionalLocalMsg9}}<br/>
      {{emotionService.emotionalLocalMsg10}}
    </div>
  </div>
  <br/>
  <div id="divPreview">
    <canvas id="canvasPreview"
            [style.visibility]="((faceRecognitionService.started)? 'visible': 'hidden')"></canvas>
  </div>
</div>

